const authorizationRegistry = new Map();

authorizationRegistry.set('admin', ['home', 'reviews', 'employees', 'create-review', 'create-employee']);
authorizationRegistry.set("employee", ["home", "reviews"]);

export const hasProfileAccessToResource = (profile, resource) => {
  let allowedResources = authorizationRegistry.get(profile);
  if (allowedResources) {
    return allowedResources.some(
      allowedResource => allowedResource === resource
    );
  }
  return resource === "home";
};



// WEBPACK FOOTER //
// ./src/services/AuthorizationSimulator.js